export default __webpack_public_path__ + "static/font-ad3355e9ed5a84b17e96cc468be844e7.woff";